import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import { dashboardQueryOptions } from './dashboard-query-options';
import {
  type AccountsReceivableDueDateGrouping,
  type Label,
} from './get-accounts-receivable-due-date-grouping';

export interface GetManualAccountsReceivableDueDateGroupingParams {
  range?: Label;
}

export const getManualAccountsReceivableDueDateGroupingAPI = async (
  params?: GetManualAccountsReceivableDueDateGroupingParams,
) => {
  const response = await baseAPI.get<Array<AccountsReceivableDueDateGrouping>>(
    '/dashboard/metrics/account-receivable/manual/duedate-grouping',
    {
      params,
    },
  );
  return response.data;
};

export const useGetManualAccountsReceivableDueDateGrouping = (
  params?: GetManualAccountsReceivableDueDateGroupingParams,
) => {
  return useQuery({
    ...dashboardQueryOptions,
    queryKey: [
      KEYS.MANUAL_ACCOUNTS_RECEIVABLE_DUE_DATE_GROUPING,
      params?.range,
    ],
    queryFn: () => getManualAccountsReceivableDueDateGroupingAPI(params),
  });
};
